import { useMemo } from 'react'
import { useSpring } from 'react-spring'
import { ExtendedStageInfo } from './useAnimationStageTimelines'

export const useMainTimeline = (stagesInfo: ExtendedStageInfo[], isExpanding: boolean) => {
  const timelineBegin = useMemo(() => getTimelineBegin(stagesInfo), [stagesInfo])
  const timelineEnd = useMemo(() => getTimelineEnd(stagesInfo), [stagesInfo])

  const spring = useSpring({
    timeline: isExpanding ? timelineEnd : timelineBegin,
    config: { duration: timelineEnd - timelineBegin }
  })

  return spring.timeline
}

export const getStageStart = (info: ExtendedStageInfo) => info.begin - info.stageOverflow.left
const getTimelineBegin = (infoList: ExtendedStageInfo[]): number => {
  return infoList.reduce((currStart, info) => Math.min(currStart, getStageStart(info)), 0)
}

export const getStageEnd = (info: ExtendedStageInfo) => info.end + info.stageOverflow.right
const getTimelineEnd = (infoList: ExtendedStageInfo[]): number => {
  return infoList.reduce((currEnd, info) => Math.max(currEnd, getStageEnd(info)), 0)
}
